/**
 * © 2026 Madar.iq — جميع الحقوق محفوظة
 */
import { useState } from "react";
import { AnimatePresence, motion, useReducedMotion } from "framer-motion";
import { Plus } from "lucide-react";
import Reveal from "./Reveal";
import { FAQ_ITEMS } from "./landing.data";

export default function FAQSection({ isArabic }) {
  const [open, setOpen] = useState(0);
  const reduce = useReducedMotion();

  return (
    <section className="gl-section" id="faq">
      <div className="gl-shell">
        <Reveal className="gl-head">
          <p className="gl-eyebrow">
            {isArabic ? "الأسئلة الشائعة" : "FAQ"}
          </p>
          <h2 className="gl-title">
            {isArabic ? "إجابات واضحة قبل الانطلاق" : "Clear answers before you launch"}
          </h2>
          <p className="gl-lead">
            {isArabic
              ? "كل ما تحتاج معرفته عن مدار المجرة في مكان واحد."
              : "Everything you need to know about Madar Galaxy in one place."}
          </p>
        </Reveal>

        <div className="gl-faq">
          {FAQ_ITEMS.map((item, i) => {
            const isOpen = open === i;
            return (
              <Reveal key={item.qEn} delay={i * 0.04}>
                <div className={`gl-faq__item${isOpen ? " is-open" : ""}`}>
                  <button
                    type="button"
                    className="gl-faq__q"
                    aria-expanded={isOpen}
                    onClick={() => setOpen(isOpen ? -1 : i)}
                  >
                    <span>{isArabic ? item.qAr : item.qEn}</span>
                    <Plus size={20} />
                  </button>
                  <AnimatePresence initial={false}>
                    {isOpen ? (
                      <motion.div
                        className="gl-faq__a"
                        key="content"
                        initial={reduce ? false : { height: 0, opacity: 0 }}
                        animate={{ height: "auto", opacity: 1 }}
                        exit={reduce ? undefined : { height: 0, opacity: 0 }}
                        transition={{ duration: 0.28, ease: [0.22, 1, 0.36, 1] }}
                      >
                        <div className="gl-faq__a-inner">
                          {isArabic ? item.aAr : item.aEn}
                        </div>
                      </motion.div>
                    ) : null}
                  </AnimatePresence>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
